import React, { useState, useEffect, useRef } from 'react'
import logo from '../../../Images/CommonImage/logo_aws_tp.png'
import { useDispatch, useSelector } from 'react-redux';
import { json, useNavigate } from "react-router-dom";
import '../Header.css'
import { SetLandingPage, setPageName, SetTopMenuNavigation } from '../../../Redux/Slices/CommonLocalRedux/NavigationSlice'
import { SetErrorStatus, setSelectedCompany } from '../../../Redux/Slices/CommonLocalRedux/CommonSliceStorage';
import { CommonBaseURl } from '../../../Commonprovider/CommonProvider'
import { Logout, UserTypeValue, UserProductIDValue } from '../../../CommonFunction/Functions';
import { Set_TOP_NAVIGATION } from '../../../Redux/Slices/CommonLocalRedux/NavigationSlice';
import { Set_LEFT_MENU_NAVIGATION } from '../../../Redux/Slices/CommonLocalRedux/NavigationSlice'
import { Set_SUB_LEFT_MENU_NAVIGATION } from '../../../Redux/Slices/CommonLocalRedux/NavigationSlice'
import { SetLeftMenuTap } from '../../../Redux/Slices/CommonLocalRedux/NavigationSlice';
import { setLeftHeadMenu } from '../../../Redux/Slices/CommonLocalRedux/NavigationSlice'
import { setselectedtab } from '../../../Redux/Slices/ScreenerRedux/CommonReduxSlices/ScreenerCommonSlice';
import Setting from '../../PopUp_Component/Setting';
import { ReachUs } from '../../PopUp_Component/ReachUs';
import { WhatsNew } from '../../PopUp_Component/WhatsNew';
import Keydefination from '../../../ExternalViewComponent/keydefinitions.pdf'
import { Watchlist } from '../../WatchList/Watchlist'
import ReactDOM from "react-dom/client";
import Store from '../../../Redux/Store/Store';
import { Provider } from 'react-redux';
// import UserGuide from '../../../ExternalViewComponent/UserGuide/UserGuide.html';
import client_image from './../../../Images/client_image.png'
import { ChangePassword } from '../../PopUp_Component/ChangePassword/ChangePassword';
import { LiveApplication } from '../../Components_Navigation/LiveApplication_Component/LiveApplication';
import { UserGuide } from '../../PopUp_Component/UserGuide/UserGuide';
import { goToCompanyModule, goToTpScreenerModule, goToEMagazineModule } from '../../../CommonFunction/ModuleNavigation';

export const DesktopHeader = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [BaseURL] = useState(CommonBaseURl)
    const Token = useSelector(state => state.Authenticationapi.token)
    const UserDetails = useSelector(state => state.LoginUserDetails.data)
    const TopNavigateTap = useSelector(state => state.Navigation.Topnavigate)
    const Peerset = useSelector((state) => state.LocalValuesData.PeersetData);
    const SeterrorStatusValue = useSelector(state => state.Navigation.ErrorStatus)
    const SelectedCompany = useSelector(state => state.LocalValuesData.SelectedCompany)
    const SelectedIndustry = useSelector(state => state.LocalValuesData.SelectedIndustry)
    const SelectedHouse = useSelector(state => state.LocalValuesData.SelectedHouse)
    const SelectedPeerset = useSelector(state => state.Screenercommon.PeersetName)
    const Landingpage = useSelector(state => state.Navigation.landingpage)
    const loginType = useSelector(state => state.LocalValuesData.loginType)
    const [TopNaviagateMenu, setTopNaviagateMenu] = useState([])
    const [ShowsettingPopup, setShowsettingPopup] = useState(false)
    const [ShowReachUsPopup, setShowReachUsPopup] = useState(false)
    const [ShowWhatsnewPopup, setShowWhatsnewPopup] = useState(false)
    const [changepPasswordPopup, setChangePasswordpopup] = useState(false)
    const Co_Code = useSelector(state => state.LocalValuesData.SelectedCompany[0]?.Co_Code)
    const ExportDetails = useSelector(state => state.LocalValuesData.ExportDetails)
    const Export = useSelector(state => state.LocalValuesData.Export)
    const Exported = useSelector(state => state.LocalValuesData.exported)
    const [showDataTooltip, setShowDataTooltip] = useState(false);
    const Subtype = useSelector((state) => state.LocalValuesData.subType)
    const [DWlimit, setDWlimit] = useState([]);
    // const userType = UserDetails[0]?.UserType == 'X ' ? 'X' : "" || JSON.parse(UserDetails)[0]?.UserType == 'X ' ? 'X' : ""
    const userType = UserTypeValue()
    const productId = UserProductIDValue()
    const [UserGuidePopup, setUserGuidePopup] = useState(false);
    const PageName = useSelector(state => state.Navigation.PageName)
    const menuRef = useRef(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleUserMenu = (e) => {
        e.stopPropagation();
        if (e.nativeEvent) {
            e.nativeEvent.stopImmediatePropagation?.();
            e.nativeEvent.stopPropagation?.();
        }
        if (e.target.closest('a') || e.target.closest('li')) {
            setIsMenuOpen(false);
        } else {
            setIsMenuOpen(prev => !prev);
        }
    };

    useEffect(() => {
        if (!isMenuOpen) return;

        const handleClickOutside = (e) => {
            if (menuRef.current && (menuRef.current === e.target || menuRef.current.contains(e.target))) {
                return;
            }
            setIsMenuOpen(false);
        };

        const timer = setTimeout(() => {
            document.addEventListener('click', handleClickOutside);
            document.addEventListener('touchstart', handleClickOutside);
        }, 0);

        return () => {
            clearTimeout(timer);
            document.removeEventListener('click', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, [isMenuOpen]);

    // useEffect(() => {
    //     // fetchData();
    //     const newParams = {
    //         "test": "Abc",
    //         "pageName": lastURL,
    //         "Coccode": Co_Code || '',
    //         "IpAdd": "",
    //         "ScreenerQuery": "",
    //         "userid": JSON.parse(UserDetails)[0].UserId,
    //         "username": JSON.parse(UserDetails)[0].UserName,
    //         "ModuleName": PageName || "Company",
    //         "Export": ExportDetails.export,
    //         "size": ExportDetails.size,
    //         "test2": "Abc"
    //     };
    //     fetch(`http://localhost:32155/api/General/UserLogsRJS`, {
    //         method: "POST",
    //         headers: {
    //             "Content-Type": "application/x-www-form-urlencoded",
    //             Authorization: `Bearer ${Token.access_token}`,
    //         },
    //         body: new URLSearchParams(newParams).toString(),
    //     })
    //         .then((response) => {
    //             if (!response.ok) {
    //                 throw new Error(`HTTP error! status: ${response.status}`);
    //             }
    //             return response.json();
    //         })
    //         .then((data) => {
    //             let usserlog = data;
    //         })
    //         .catch((error) => {
    //             console.error("Error fetching matched companies:", error);
    //         });
    //     // }
    // }, [Co_Code, lastURL, PageName, Exported]);


    const NodeName = (Navigatename) => {
        if ((SelectedCompany !== '' && SelectedIndustry !== '' && SelectedHouse !== '')) {
            switch (Navigatename) {
                case 'Home':
                    navigate('/Landing');
                    dispatch(SetErrorStatus(false));
                    dispatch(SetErrorStatus(false));
                    dispatch(SetLeftMenuTap(''))
                    dispatch(setLeftHeadMenu(''))
                    dispatch(Set_TOP_NAVIGATION(''))
                    dispatch(Set_LEFT_MENU_NAVIGATION(''))
                    dispatch(Set_SUB_LEFT_MENU_NAVIGATION(''))
                    break;
                case 'Company':
                    goToCompanyModule(dispatch, navigate);
                    break;
                case 'Industry':
                    navigate(`/Industry/General/IndustryFactSheet`);
                    dispatch(SetErrorStatus(false));
                    dispatch(SetLeftMenuTap(''))
                    dispatch(setLeftHeadMenu('IndustryFactSheet'))
                    dispatch(setPageName("FactSheet"))
                    dispatch(Set_TOP_NAVIGATION(''))
                    dispatch(Set_LEFT_MENU_NAVIGATION(''))
                    dispatch(Set_SUB_LEFT_MENU_NAVIGATION(''))
                    break;
                case 'House':
                    navigate(`/House/General/HouseFactSheet`);
                    dispatch(SetErrorStatus(false));
                    dispatch(SetLeftMenuTap(''))
                    dispatch(setLeftHeadMenu('House'))
                    dispatch(setPageName("FactSheet"))
                    dispatch(Set_TOP_NAVIGATION(''))
                    dispatch(Set_LEFT_MENU_NAVIGATION(''))
                    dispatch(Set_SUB_LEFT_MENU_NAVIGATION(''))
                    break;
                case 'Peerset':
                    navigate(`/Landing`);
                    dispatch(SetErrorStatus(false));
                    dispatch(SetLeftMenuTap('PeersetFact Sheet'))
                    dispatch(setLeftHeadMenu('Peerset'))
                    dispatch(setPageName("FactSheet"))
                    dispatch(Set_TOP_NAVIGATION(''))
                    dispatch(Set_LEFT_MENU_NAVIGATION(''))
                    dispatch(Set_SUB_LEFT_MENU_NAVIGATION(''))
                    if (Peerset.length === 0) {
                        alert("Please create Peerset from screener module")
                    }
                    break;
                case 'Ipo':
                    navigate(`Ipo/IPO/IpoIssuesOpen`);
                    dispatch(SetLeftMenuTap('Issues Open'))
                    dispatch(setLeftHeadMenu('Issues'))
                    dispatch(setPageName("Issues Open"))
                    dispatch(Set_TOP_NAVIGATION('ipo'))
                    dispatch(Set_LEFT_MENU_NAVIGATION('issues'))
                    dispatch(Set_SUB_LEFT_MENU_NAVIGATION('issuesopen'))
                    break;
                case 'FactSheet':
                    navigate(`factSheet/Index`);
                    dispatch(SetLeftMenuTap('FactSheet'))
                    dispatch(setLeftHeadMenu('FactSheet'))
                    break;
                case 'Reports & Analytics':
                    navigate(`/reportsandanalytics/mffiidailyturnover/fiifpitradingactivity`)
                    dispatch(SetLeftMenuTap('FII/FPI Trading Activity'))
                    dispatch(setLeftHeadMenu('MF/FII Daily Turnover'))
                    break;
                case 'Add-Ons':
                    // navigate('/Landing');
                    navigate('/liveapplication');

                    // <LiveApplication />
                    break;
                case 'CM- Live News':
                    navigate(`cmlivenews/cmlivenews/marketcommentary`);
                    dispatch(SetLeftMenuTap('Market Commentary'))
                    dispatch(setLeftHeadMenu('CM-Live News'))
                    dispatch(setPageName("Market Commentary"))

                    break;
                case 'Screener':
                    navigate(`/screener/domain`)
                    dispatch(setselectedtab('domain'))
                    break;
                case 'CS':
                    navigate(`customizedscreen/customizedscreen/financefield`)
                    dispatch(SetErrorStatus(false));
                    dispatch(SetLeftMenuTap(''))
                    dispatch(setLeftHeadMenu('Customized Screen'))
                    dispatch(setPageName("Finance Field"))
                    dispatch(Set_TOP_NAVIGATION(''))
                    dispatch(Set_LEFT_MENU_NAVIGATION(''))
                    dispatch(Set_SUB_LEFT_MENU_NAVIGATION(''))
                    break;
                case 'TP Screener': {
                    if (window.location.pathname && !window.location.pathname.startsWith('/tp-screener')) {
                        sessionStorage.setItem('main_app_last_url', window.location.pathname + window.location.search);
                        sessionStorage.setItem('main_app_top_nav', JSON.stringify(TopNavigateTap));
                    }
                    goToTpScreenerModule(dispatch, navigate);
                    break;
                }
                case 'e-Magazine': {
                    if (window.location.pathname && !window.location.pathname.startsWith('/e-magazine')) {
                        sessionStorage.setItem('main_app_last_url', window.location.pathname + window.location.search);
                        sessionStorage.setItem('main_app_top_nav', JSON.stringify(TopNavigateTap));
                    }
                    goToEMagazineModule(dispatch, navigate);
                    break;
                }
            }
        } else if (Navigatename == 'e-Magazine') {
            if (window.location.pathname && !window.location.pathname.startsWith('/e-magazine')) {
                sessionStorage.setItem('main_app_last_url', window.location.pathname + window.location.search);
                sessionStorage.setItem('main_app_top_nav', JSON.stringify(TopNavigateTap));
            }
            goToEMagazineModule(dispatch, navigate);
        } else if (Navigatename == 'TP Screener') {
            if (window.location.pathname && !window.location.pathname.startsWith('/tp-screener')) {
                sessionStorage.setItem('main_app_last_url', window.location.pathname + window.location.search);
                sessionStorage.setItem('main_app_top_nav', JSON.stringify(TopNavigateTap));
            }
            goToTpScreenerModule(dispatch, navigate);
        } else if (Navigatename == 'Screener') {
            dispatch(setselectedtab('domain'))
            navigate('/screener/domain');
        } else if (Navigatename == 'Reports & Analytics') {
            navigate(`/reportsandanalytics/mffiidailyturnover/fiifpitradingactivity`)
        } else if (Navigatename == 'Industry' && SelectedCompany !== '') {
            navigate(`/Industry/General/IndustryFactSheet`);
            dispatch(SetErrorStatus(false));
            dispatch(SetLeftMenuTap(''))
            dispatch(setLeftHeadMenu('IndustryFactSheet'))
            dispatch(setPageName("FactSheet"))
            dispatch(Set_TOP_NAVIGATION(''))
            dispatch(Set_LEFT_MENU_NAVIGATION(''))
            dispatch(Set_SUB_LEFT_MENU_NAVIGATION(''))
        }
        else if (Navigatename == 'House' && SelectedCompany !== '') {
            navigate(`/House/General/HouseFactSheet`);
            dispatch(SetErrorStatus(false));
            dispatch(SetLeftMenuTap(''))
            dispatch(setLeftHeadMenu('House'))
            dispatch(setPageName("FactSheet"))
            dispatch(Set_TOP_NAVIGATION(''))
            dispatch(Set_LEFT_MENU_NAVIGATION(''))
            dispatch(Set_SUB_LEFT_MENU_NAVIGATION(''))
        }
        else if (Navigatename == 'FactSheet') {
            navigate(`factSheet/Index`);
        }
        else if (Navigatename == 'Peerset') {
            if (Peerset.length === 0) {
                alert("Please create Peerset from screener module")
            }
            if (SelectedPeerset == '') {
                navigate('/Landing');
            } else {
                navigate(`/Peerset/Peerset/PeersetFactSheet`);
            }
            dispatch(SetErrorStatus(false));
            dispatch(SetLeftMenuTap('PeersetFact Sheet'))
            dispatch(setLeftHeadMenu('Peerset'))
            dispatch(setPageName("FactSheet"))
            dispatch(Set_TOP_NAVIGATION(''))
            dispatch(Set_LEFT_MENU_NAVIGATION(''))
            dispatch(Set_SUB_LEFT_MENU_NAVIGATION(''))
        }
        else if (Navigatename == 'Ipo') {
            navigate(`Ipo/IPO/IpoIssuesOpen`);
            dispatch(SetLeftMenuTap('Issues Open'))
            dispatch(setLeftHeadMenu('Issues'))
            dispatch(setPageName("Issues Open"))
            dispatch(Set_TOP_NAVIGATION('ipo'))
            dispatch(Set_LEFT_MENU_NAVIGATION('issues'))
            dispatch(Set_SUB_LEFT_MENU_NAVIGATION('issuesopen'))
        }
        else if (Navigatename == 'CM- Live News') {
            navigate(`cmlivenews/cmlivenews/marketcommentary`);
            dispatch(SetLeftMenuTap('Market Commentary'))
            dispatch(setLeftHeadMenu('CM-Live News'))
            dispatch(setPageName("Market Commentary"))
        }
        else if (Navigatename == 'Add-Ons') {
            navigate('/liveapplication')
        }
        else {
            dispatch(SetErrorStatus(true));
            navigate('/Landing');
        }
    }
    useEffect(() => {
        let Userid = sessionStorage.getItem("getuserid");
        if (Token != null) {
            fetch(`${BaseURL}GetNavigateBarMENU?userid=${Userid}&SD_Active=${userType || ""}`, {
                method: "GET",
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    Authorization: "Bearer " + Token.access_token,
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    let data1 = JSON.parse(data);
                    setTopNaviagateMenu(data1);
                });
        }
    }, [])
    const openUserGuide = () => {
        const fileUrl = `${window.location.origin}/UserGuide/UserGuide.html`;
        window.open(fileUrl, "_blank");
    };

    const openViewDemo = () => {
        const fileUrl = `${window.location.origin}/ViewDemo/viewdemo.html`;
        window.open(fileUrl, "_blank");
    }

    const openPdf = async () => {
        const response = await fetch(`${window.location.origin}/UserGuide/userGuide.pdf`);
        const pdfBlob = await response.blob();
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank', 'noopener,noreferrer');
    };


    const openWatchList = () => {
        window.open("/watchlist", "_blank");
    };




    function formatKB(kb) {
        const KB_IN_MB = 1024;
        const KB_IN_GB = 1024 * 1024;

        if (kb >= KB_IN_GB) {
            const gb = Math.round(kb / KB_IN_GB);
            return `${gb} GB`;
        }

        const mb = Math.round(kb / KB_IN_MB);
        return `${mb} MB`;
    }

    function formatUsageTooltip(usedKB, remainingKB, limitKB) {
        return `Used: ${formatKB(usedKB)}; Remaining: ${formatKB(remainingKB)}; Limit: ${formatKB(limitKB)}`;
    }


    function getBudgetLabel(year = new Date().getFullYear()) {
        const nextYearShort = String(year + 1).slice(-2);
        return `Budget ${year}-${nextYearShort}`;
    }

    // useEffect(() => {
    //     fetch(`${BaseURL}GetDownloadSize?UserID=${UserDetails[0].ParentUserid || JSON.parse(UserDetails)[0].ParentUserid}`, {
    //         method: "GET",
    //         headers: {
    //             "Content-type": "application/json; charset=UTF-8",
    //             Authorization: "Bearer " + Token.access_token,
    //         },
    //     })
    //         .then((response) => response.json())
    //         .then((json) => {
    //             let data1 = JSON.parse(json);
    //             setDWlimit(data1)
    //         });
    // }, [Exported]);


    return (
        <>
            <div className="header-desktop">
                <div className="logo-container" onClick={() => { navigate('/Landing'); dispatch(SetTopMenuNavigation([2, 'Home'])); dispatch(SetLandingPage(true)) }}>
                    <img src={logo} alt="" className="img-fluid" />
                </div>
                <ul className='header-links'>
                    {TopNaviagateMenu && TopNaviagateMenu.map((data) => {
                        const nodeName = data?.NODENAME || '';
                        const lower = nodeName.toLowerCase();
                        if (
                            nodeName === 'CS' ||
                            nodeName === 'Home' ||
                            nodeName === 'Screener' ||
                            lower === 'screener' ||
                            nodeName === 'e-Magazine'
                        ) {
                            return null;
                        }

                        return (
                            <li
                                key={data.Navigate_ID || nodeName}
                                className={
                                    ((TopNavigateTap[1] === 'Home' && !Landingpage ? 'Company' : TopNavigateTap[1]) === nodeName)
                                        ? "active"
                                        : ""
                                }
                                onClick={() => {
                                    dispatch(SetTopMenuNavigation(nodeName === 'Home'
                                        ? [2, 'Home']
                                        : [data.Navigate_ID, nodeName]));
                                    NodeName(nodeName);
                                }}
                            >
                                <span>{nodeName === 'Ipo' ? 'IPO' : nodeName}</span>
                            </li>
                        );
                    })}

                    {(!TopNaviagateMenu || !TopNaviagateMenu.some(d => (d?.NODENAME || '').toLowerCase() === 'tp screener')) && (
                        <li
                            className={TopNavigateTap[1] === 'TP Screener' ? "active" : ""}
                            onClick={() => {
                                dispatch(SetTopMenuNavigation([98, 'TP Screener']));
                                NodeName('TP Screener');
                            }}
                        >
                            <span>TP Screener</span>
                        </li>
                    )}

                    {String(productId) === '4' && (
                        <li
                            className={TopNavigateTap[1] === 'e-Magazine' ? "active" : ""}
                            onClick={() => {
                                dispatch(SetTopMenuNavigation([99, 'e-Magazine']));
                                NodeName('e-Magazine');
                            }}
                        >
                            <span>e-Magazine</span>
                        </li>
                    )}
                </ul>
                <div
                    className={`user-details ${isMenuOpen ? 'open active' : ''}`}
                    ref={menuRef}
                    role="button"
                    tabIndex={0}
                    onClick={toggleUserMenu}
                    style={{ cursor: 'pointer', position: 'relative' }}
                >
                    <div className="common-dropdown">
                        <span className="user-name-text">
                            {UserDetails && UserDetails.length != 0 ? UserDetails[0].UserName || JSON.parse(UserDetails)[0].UserName : ''}
                        </span>
                    </div>
                    <div className="user-img">
                        <img src={client_image} alt='' />
                    </div>
                    <ul
                        className={`user-dropdown-menu ${isMenuOpen ? 'show-menu' : ''}`}
                        style={{ display: isMenuOpen ? 'block' : undefined }}
                    >
                        <li>
                            <a href={Keydefination} target='_blank' rel="noreferrer" onClick={() => setIsMenuOpen(false)}>Key Definition</a>
                        </li>
                        <li>
                            <a onClick={() => { setShowsettingPopup(true); setIsMenuOpen(false); }}>Settings</a>
                        </li>
                        {/* {DWlimit?.[0]?.DWLimit > 0 && (
                            <li className="data-usage-item">
                                <a
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setShowDataTooltip(prev => !prev);
                                    }}
                                    onMouseEnter={() => setShowDataTooltip(true)}
                                    onMouseLeave={() => setShowDataTooltip(false)}
                                >
                                    Data Usage
                                </a>
                                {showDataTooltip && (
                                    <div className="data-usage-tooltipdrp">
                                        <div className="tooltip-title">
                                            <span className="info-icon small">i</span>
                                            <strong>Data Usage</strong>
                                        </div>
                                        <div className="tooltip-content">
                                            <p> Used: {formatKB(DWlimit[0]?.TotalExportSize)}</p>
                                            <p> Remaining: {formatKB(DWlimit[0]?.Remaining)}</p>
                                            <p> Limit: {formatKB(DWlimit[0]?.DWLimit)}</p>
                                        </div>
                                    </div>
                                )}
                            </li>
                        )} */}
                        <li>
                            <a onClick={() => { setChangePasswordpopup(true); setIsMenuOpen(false); }}>Change Password</a>
                        </li>
                        <li onClick={() => { setIsMenuOpen(false); Logout(loginType); }}>
                            <a>Logout</a>
                        </li>
                    </ul>
                </div>

            </div>
            {ShowsettingPopup && <Setting setShowsettingPopup={setShowsettingPopup} />}
            {/* {ShowReachUsPopup && <ReachUs setShowReachUsPopup={setShowReachUsPopup} />} */}
            {ShowWhatsnewPopup && <WhatsNew setShowWhatsnewPopup={setShowWhatsnewPopup} />}
            {changepPasswordPopup && <ChangePassword setChangePasswordpopup={setChangePasswordpopup} />}
            {UserGuidePopup && <UserGuide setUserGuidePopup={setUserGuidePopup} />}
        </>

    )
}
